import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/lib/utils/formatters";
import { PropsWithChildren } from "react";

type CriterionDetails = Record<string, unknown> | undefined;

const CriterionDetailsBadge = ({ children }: PropsWithChildren) => (
  <Badge variant="outline" className="text-sm text-muted-foreground">
    {children}
  </Badge>
);

export const CriterionDetails = ({
  details,
}: {
  details: CriterionDetails;
}) => {
  const { t } = useTranslation();

  if (!details) return null;

  const parts: JSX.Element[] = [];

  for (const [key, value] of Object.entries(details)) {
    if (value === null || value === undefined) {
      continue;
    }

    const translationKey = `projectPeriodConfirmation.details.${key}`;
    const safeValue = String(value);

    switch (key) {
      case "utilization_percent":
        parts.push(
          <CriterionDetailsBadge key={key}>{safeValue}%</CriterionDetailsBadge>,
        );
        break;
      case "project_end_date":
      case "minimum_required_end_date":
        parts.push(
          <span key={key}>
            {t(translationKey)}{" "}
            <CriterionDetailsBadge>
              {formatDate(safeValue)}
            </CriterionDetailsBadge>
          </span>,
        );
        break;
      default:
        parts.push(
          <span key={key}>
            {t(translationKey)}{" "}
            <CriterionDetailsBadge>{safeValue}</CriterionDetailsBadge>
          </span>,
        );
    }
  }

  if (parts.length === 0) return null;

  return <span className="flex flex-wrap gap-y-1 gap-x-3">{parts}</span>;
};
